var exports = {
  "M": "kebabButton__x9Sjvp",
};

module.exports = exports;
